import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import './App.css';
import './reporteOperativo.css';
import { createClient } from '@supabase/supabase-js';
import { permissions } from './config/permissions';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Inbox from './components/Inbox';
import ChatPanel from './components/ChatPanel';
import ContextPanel from './components/ContextPanel';
import SalesModal from './components/SalesModal';
import ReporteOperativo from './components/ReporteOperativo';
import MarketingPanel from './components/MarketingPanel';
import ImplementacionPanel from './components/ImplementacionPanel';
import OutboundPanel from './components/OutboundPanel';
import OutboundV12Panel from './components/OutboundV12Panel';
import CatalogoPanel from './components/CatalogoPanel';
import AdsManagerPanel from './components/AdsManagerPanel';
import './marketing.css';

// â”€â”€ Constantes compartidas (fuente Ãºnica) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
import {
  ETAPAS_VENTAS,
  ESTADOS_ATENCION,
  ESTADOS_SOPORTE,
  ESTADOS_ACTIVOS,
  VENTAS_STORAGE_KEY,
  ATENCION_STORAGE_KEY,
  SOPORTE_STORAGE_KEY,
  DEFAULT_SALES_SUMMARY,
  DEMO_USERS,
  LOCALIDADES_EXPANSION,
  API_URL,
} from './constants';

// â”€â”€ Funciones utilitarias puras â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
import {
  authFetch,
  normalizarTexto,
  normalizarTelefonoVisual,
  formatDateTimeLocal,
  formatearEntreCalles,
  esDocumentoValido,
  esProbableDireccion,
  esLocalidadValida,
  capitalizarCadaPalabra,
  extraerEmailDesdeMensajes,
  extraerDocumentoDesdeMensajes,
  extraerDireccionDesdeMensajes,
  extraerNombreCompletoDesdeMensajes,
  extraerPrecioDesdeMensajes,
  extraerMedioPagoDesdeMensajes,
  inferirLocalidadDesdeDireccion,
  limpiarDireccionSinLocalidad,
  geocodificarResumenVenta as geocodificarResumenVentaFrontend,
  crearFormularioVentaInicial,
} from './utils';
import useVentas from './hooks/useVentas';
import useAtencion from './hooks/useAtencion';
import useSoporte from './hooks/useSoporte';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL || 'https://nsfnhzqrhcippaheyiev.supabase.co',
  process.env.REACT_APP_SUPABASE_ANON_KEY || 'REEMPLAZAR_CON_TU_ANON_KEY'
);



// demoUsers importado como DEMO_USERS desde constants.js
const demoUsers = DEMO_USERS;

// â”€â”€ Pantalla de Login â”€â”€
function Login({ onLogin }) {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [cargando, setCargando] = React.useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Error al iniciar sesiÃ³n'); return; }
      localStorage.setItem('wc_token', data.token);
      localStorage.setItem('wc_agente', JSON.stringify(data.agente));
      onLogin(data.agente, data.token);
    } catch { setError('Error de conexiÃ³n. VerificÃ¡ tu internet.'); }
    finally { setCargando(false); }
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1a1a2e 0%,#16213e 50%,#0f3460 100%)',display:'flex',alignItems:'center',justifyContent:'center',padding:'20px',fontFamily:'-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif'}}>
      <div style={{background:'rgba(255,255,255,0.05)',backdropFilter:'blur(20px)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'20px',padding:'40px',width:'100%',maxWidth:'400px',boxShadow:'0 25px 50px rgba(0,0,0,0.5)'}}>
        <div style={{display:'flex',alignItems:'center',gap:'14px',marginBottom:'36px'}}>
          <div style={{width:'48px',height:'48px',borderRadius:'14px',background:'linear-gradient(135deg,#7c3aed,#4f46e5)',color:'white',fontWeight:'800',fontSize:'18px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>WC</div>
          <div>
            <div style={{color:'white',fontWeight:'700',fontSize:'20px'}}>WeConnect</div>
            <div style={{color:'rgba(255,255,255,0.5)',fontSize:'12px'}}>Dashboard v2.0</div>
          </div>
        </div>
        <form onSubmit={handleLogin} style={{display:'flex',flexDirection:'column',gap:'16px'}}>
          <div style={{display:'flex',flexDirection:'column',gap:'6px'}}>
            <label style={{color:'rgba(255,255,255,0.7)',fontSize:'13px',fontWeight:'500'}}>Email</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="tu@weconnect.ar" required autoFocus
              style={{background:'rgba(255,255,255,0.08)',border:'1px solid rgba(255,255,255,0.15)',borderRadius:'10px',padding:'12px 14px',color:'white',fontSize:'15px',outline:'none'}} />
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:'6px'}}>
            <label style={{color:'rgba(255,255,255,0.7)',fontSize:'13px',fontWeight:'500'}}>ContraseÃ±a</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢" required
              style={{background:'rgba(255,255,255,0.08)',border:'1px solid rgba(255,255,255,0.15)',borderRadius:'10px',padding:'12px 14px',color:'white',fontSize:'15px',outline:'none'}} />
          </div>
          {error && <div style={{background:'rgba(239,68,68,0.15)',border:'1px solid rgba(239,68,68,0.3)',borderRadius:'8px',padding:'10px 14px',color:'#fca5a5',fontSize:'13px'}}>{error}</div>}
          <button type="submit" disabled={cargando}
            style={{background:'linear-gradient(135deg,#7c3aed,#4f46e5)',border:'none',borderRadius:'10px',padding:'13px',color:'white',fontWeight:'600',fontSize:'15px',cursor:cargando?'not-allowed':'pointer',opacity:cargando?0.7:1}}>
            {cargando ? 'Ingresando...' : 'Ingresar'}
          </button>
          <div style={{color:'rgba(255,255,255,0.35)',fontSize:'12px',textAlign:'center'}}>Â¿Problemas para ingresar? ContactÃ¡ a Fernando.</div>
        </form>
      </div>
    </div>
  );
}

function App() {
  // â”€â”€ AutenticaciÃ³n â”€â”€
  const [autenticado, setAutenticado] = useState(() => {
    const token = localStorage.getItem('wc_token');
    const agente = localStorage.getItem('wc_agente');
    if (!token || !agente) return false;
    // Verificar que el token no expirÃ³
    try {
      const data = token.split('.')[0];
      const payload = JSON.parse(atob(data));
      if (payload.exp < Date.now()) {
        localStorage.removeItem('wc_token');
        localStorage.removeItem('wc_agente');
        return false;
      }
      return true;
    } catch { return false; }
  });

  const handleLogin = (agente, token) => {
    setAutenticado(true);
    setAgenteLogueadoId(agente.id);
    localStorage.setItem('weconnect_agente_id', agente.id);

    // Marcar agente como online en el backend
    authFetch(`${API_URL}/api/dashboard/agente/${agente.id}/online`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ online: true }),
    }).catch(err => console.error('[ONLINE] Error marcando online:', err.message));
  };

  const handleLogout = () => {
    // Marcar agente como offline en el backend
    const agenteId = localStorage.getItem('weconnect_agente_id');
    if (agenteId) {
      authFetch(`${API_URL}/api/dashboard/agente/${agenteId}/online`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ online: false }),
      }).catch(err => console.error('[ONLINE] Error marcando offline:', err.message));
    }

    localStorage.removeItem('wc_token');
    localStorage.removeItem('wc_agente');
    localStorage.removeItem('weconnect_agente_id');
    setAutenticado(false);
    setAgenteLogueadoId(null);
  };

  // Marcar offline cuando cierra la pestaña
  useEffect(() => {
    const marcarOffline = () => {
      const agenteId = localStorage.getItem('weconnect_agente_id');
      if (!agenteId) return;
      const url = `${API_URL}/api/dashboard/agente/${agenteId}/online`;
      const body = JSON.stringify({ online: false });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
      }
    };

    window.addEventListener('beforeunload', marcarOffline);
    return () => window.removeEventListener('beforeunload', marcarOffline);
  }, []);

  const [selectedDemoUserId, setSelectedDemoUserId] = useState('admin-general');
  const [agenteLogueadoId, setAgenteLogueadoId] = useState(() => localStorage.getItem('weconnect_agente_id') || null);

  const currentUser =
    demoUsers.find((u) => u.id === selectedDemoUserId) || demoUsers[0];

  const currentPermissions = permissions[currentUser.nivel] || permissions.agente;
  const areasHabilitadas =
    currentUser.nivel === 'admin' || currentUser.nivel === 'supervisor'
      ? ['ventas', 'atencion', 'soporte', 'marketing']
      : currentUser.areas || [];

  const [conversaciones, setConversaciones] = useState([]);
  const [agentes, setAgentes] = useState([]);
  const [conversacionActiva, setConversacionActiva] = useState(null);
  const [mensajes, setMensajes] = useState([]);
  const [adjuntosRecientes, setAdjuntosRecientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('todas');
  const [busqueda, setBusqueda] = useState('');
  const [nuevoMensaje, setNuevoMensaje] = useState('');
  const [vistaActiva, setVistaActiva] = useState('activas');
  const [outboundTab, setOutboundTab] = useState('v12');
  const [datosCliente, setDatosCliente] = useState(null);
  const [enviandoMensaje, setEnviandoMensaje] = useState(false);
  const [cambiandoIA, setCambiandoIA] = useState(false);
  const [estadoOperativoBackend, setEstadoOperativoBackend] = useState(null);
  const [guardandoEstado, setGuardandoEstado] = useState(false);

  const conversacionActivaRef = useRef(null);

  // FIX MEDIA DASHBOARD LOCAL START
  const MEDIA_LOCAL_DASHBOARD_KEY = 'weconnect_media_local_messages_v1';

  const leerMediaLocalDashboard = (convId) => {
    if (!convId) return [];

    try {
      const data = JSON.parse(localStorage.getItem(MEDIA_LOCAL_DASHBOARD_KEY) || '{}');
      const key = String(convId);
      return Array.isArray(data[key]) ? data[key] : [];
    } catch (e) {
      console.error('Error leyendo media local dashboard:', e);
      return [];
    }
  };

  const guardarMediaLocalDashboard = (convId, mensaje) => {
    if (!convId || !mensaje) return;

    try {
      const data = JSON.parse(localStorage.getItem(MEDIA_LOCAL_DASHBOARD_KEY) || '{}');
      const key = String(convId);
      const actuales = Array.isArray(data[key]) ? data[key] : [];

      const sinDuplicado = actuales.filter((msg) => {
        if (mensaje.id && msg.id && String(msg.id) === String(mensaje.id)) return false;
        if (mensaje.tempId && msg.tempId && String(msg.tempId) === String(mensaje.tempId)) return false;
        return true;
      });

      data[key] = [...sinDuplicado, mensaje].slice(-30);
      localStorage.setItem(MEDIA_LOCAL_DASHBOARD_KEY, JSON.stringify(data));
    } catch (e) {
      console.error('Error guardando media local dashboard:', e);
    }
  };

  const mergeMensajesDashboard = (mensajesBackend = [], mensajesLocales = []) => {
    const resultado = Array.isArray(mensajesBackend) ? [...mensajesBackend] : [];

    for (const localMsg of mensajesLocales || []) {
      const existe = resultado.some((msg) => {
        if (localMsg.id && msg.id && String(localMsg.id) === String(msg.id)) return true;
        if (localMsg.tempId && msg.tempId && String(localMsg.tempId) === String(msg.tempId)) return true;

        const mediaLocal = localMsg.media_url || localMsg.archivo_url || localMsg.file_url;
        const mediaBackend = msg.media_url || msg.archivo_url || msg.file_url;

        if (mediaLocal && mediaBackend && String(mediaLocal) === String(mediaBackend)) return true;

        return false;
      });

      if (!existe) {
        resultado.push(localMsg);
      }
    }

    return resultado.sort((a, b) => {
      const ta = new Date(a.created_at || a.fecha || 0).getTime() || 0;
      const tb = new Date(b.created_at || b.fecha || 0).getTime() || 0;
      return ta - tb;
    });
  };

  useEffect(() => {
    const handler = (event) => {
      const detail = event.detail || {};
      const convId = detail.conversacionId ? String(detail.conversacionId) : null;
      const mensaje = detail.mensaje;

      if (!convId || !mensaje) return;

      guardarMediaLocalDashboard(convId, mensaje);

      const activa = conversacionActivaRef.current;

      if (activa?.id && String(activa.id) === convId) {
        setMensajes((prev) => mergeMensajesDashboard(prev, [mensaje]));
      }

      setTimeout(() => {
        const activaDespues = conversacionActivaRef.current;

        if (activaDespues?.id && String(activaDespues.id) === convId) {
          cargarMensajes(convId);
        }

        cargarConversaciones();
      }, 800);
    };

    window.addEventListener('weconnect:media-enviada', handler);

    return () => {
      window.removeEventListener('weconnect:media-enviada', handler);
    };
  }, []);
  // FIX MEDIA DASHBOARD LOCAL END

  const tieneAccesoArea = (categoria) => {
    if (!categoria) return true;
    if (currentUser.nivel === 'admin' || currentUser.nivel === 'supervisor') return true;
    return areasHabilitadas.includes(categoria);
  };

  useEffect(() => {
    conversacionActivaRef.current = conversacionActiva;
  }, [conversacionActiva]);

  useEffect(() => {
    const filtrosGlobales = ['todas', 'criticas', 'pendientes', 'derivadas', 'metricas', 'marketing', 'implementacion', 'outbound', 'catalogo', 'ads', 'historial', 'vistas', 'ia_activa', 'mi_cola', 'mias'];
    // Aceptar subfiltros de área: ventas_ia, ventas_derivadas, atencion_ia, etc.
    const esSubfiltroArea = /^(.+)_(ia|derivadas)$/.test(filtro) && areasHabilitadas.includes(filtro.replace(/_(ia|derivadas)$/, ''));
    if (!filtrosGlobales.includes(filtro) && !areasHabilitadas.includes(filtro) && !esSubfiltroArea) {
      setFiltro('todas');
    }
  }, [filtro, areasHabilitadas]);

  useEffect(() => {
    if (conversacionActiva && !tieneAccesoArea(conversacionActiva.categoria || conversacionActiva.area)) {
      setConversacionActiva(null);
      setMensajes([]);
      setDatosCliente(null);
      setEstadoOperativoBackend(null);
    }
  }, [selectedDemoUserId]);

  const cargarConversaciones = async () => {
    try {
      const response = await authFetch(`${API_URL}/api/dashboard/conversaciones`);
      const data = await response.json();
      const nuevas = Array.isArray(data?.conversaciones) ? data.conversaciones : [];
      setConversaciones(nuevas);

      // FIX 27/05: Mantener conversación seleccionada durante polling
      // Sin esto, al refrescar la bandeja el objeto cambia de referencia
      // y el componente pierde la selección (salta a otra conversación)
      setConversacionActiva(prev => {
        if (!prev) return null;
        const misma = nuevas.find(c => c.id === prev.id);
        return misma || prev;
      });
    } catch (error) {
      console.error('Error cargando conversaciones:', error);
      setConversaciones([]);
    }
  };

  const cargarAgentes = async () => {
    try {
      const response = await authFetch(`${API_URL}/api/dashboard/agentes`);
      const data = await response.json();
      setAgentes(Array.isArray(data?.agentes) ? data.agentes : []);
    } catch (error) {
      console.error('Error cargando agentes:', error);
      setAgentes([]);
    }
  };

  const cargarMensajes = async (id) => {
    if (!id) {
      setMensajes([]);
      setAdjuntosRecientes([]);
      return;
    }

    try {
      const response = await authFetch(`${API_URL}/api/dashboard/conversacion/${id}`);
      const data = await response.json();
            const mensajesBackend = Array.isArray(data?.mensajes) ? data.mensajes : [];
      const mensajesLocales = leerMediaLocalDashboard(id);
      setMensajes(mergeMensajesDashboard(mensajesBackend, mensajesLocales));

      try {
        const adjResp = await authFetch(`${API_URL}/api/dashboard/conversacion/${id}/adjuntos-recientes?dias=7`);
        const adjData = await adjResp.json();
        setAdjuntosRecientes(Array.isArray(adjData?.adjuntos) ? adjData.adjuntos : []);
      } catch (adjErr) {
        console.error('Error cargando adjuntos recientes:', adjErr);
        setAdjuntosRecientes([]);
      }
    } catch (error) {
      console.error('Error cargando mensajes:', error);
      setMensajes([]);
      setAdjuntosRecientes([]);
    }
  };

  const cargarDatosCliente = async (telefono) => {
    if (!telefono) {
      setDatosCliente(null);
      return;
    }

    try {
      setDatosCliente(null);

      const response = await authFetch(
        `${API_URL}/api/dashboard/ispcube/cliente/${encodeURIComponent(telefono)}`
      );

      if (response.ok) {
        const data = await response.json();
        setDatosCliente(
          data || {
            plan: 'Sin datos',
            estado: 'Sin datos',
            deuda: 0,
            saldo_a_favor: 0,
          }
        );
      } else {
        setDatosCliente({
          plan: 'Sin datos',
          estado: 'Sin datos',
          deuda: 0,
          saldo_a_favor: 0,
        });
      }
    } catch (error) {
      console.error('Error cargando datos cliente:', error);
      setDatosCliente({
        plan: 'Sin datos',
        estado: 'Sin datos',
        deuda: 0,
        saldo_a_favor: 0,
      });
    }
  };

  const cargarEstadoOperativo = async (id) => {
    if (!id) {
      setEstadoOperativoBackend(null);
      return;
    }

    try {
      const response = await authFetch(`${API_URL}/api/dashboard/conversacion/${id}/estado-operativo`);
      const data = await response.json();
      setEstadoOperativoBackend(data?.estado || null);
    } catch (error) {
      console.error('Error cargando estado operativo:', error);
      setEstadoOperativoBackend(null);
    }
  };

  const guardarEstadoOperativo = async ({
    area,
    campo,
    valor,
    observacion = null,
    proxima_accion = null,
    visita_tecnica = null,
  }) => {
    if (!conversacionActiva?.id || guardandoEstado) return false;

    try {
      setGuardandoEstado(true);

      const response = await authFetch(
        `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/estado-operativo`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            area,
            campo,
            valor,
            observacion,
            proxima_accion,
            visita_tecnica,
            usuario_id: null,
          }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        console.error('Error guardando estado operativo:', data);
        alert(`âŒ Error guardando estado: ${data?.error || 'desconocido'}`);
        return false;
      }

      setEstadoOperativoBackend(data?.estado || null);
      return true;
    } catch (error) {
      console.error('Error guardando estado operativo:', error);
      alert('âŒ Error de conexiÃ³n guardando estado');
      return false;
    } finally {
      setGuardandoEstado(false);
    }
  };

  const cargarDatosIniciales = async () => {
    setLoading(true);
    await Promise.all([cargarConversaciones(), cargarAgentes()]);
    setLoading(false);
  };

  useEffect(() => {
    cargarDatosIniciales();
  }, []);

  useEffect(() => {
    if (!conversacionActiva?.id) {
      setMensajes([]);
      setEstadoOperativoBackend(null);
      return;
    }
    cargarMensajes(conversacionActiva.id);
    cargarEstadoOperativo(conversacionActiva.id);
  }, [conversacionActiva?.id]);

  useEffect(() => {
    if (!conversacionActiva?.telefono) {
      setDatosCliente(null);
      return;
    }
    cargarDatosCliente(conversacionActiva.telefono);
  }, [conversacionActiva?.telefono]);

  // ═══ SUPABASE REALTIME — Modo principal ═══
  // Escucha cambios en conversaciones y mensajes en tiempo real.
  // El polling queda como respaldo cada 30s por si Realtime se desconecta.
  useEffect(() => {
    const channel = supabase
      .channel('dashboard-realtime')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'conversaciones' },
        (payload) => {
          console.log('[REALTIME] Cambio en conversaciones:', payload.eventType);
          cargarConversaciones();
        }
      )
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'mensajes' },
        (payload) => {
          const activa = conversacionActivaRef.current;
          // Siempre actualizar bandeja (para unread dots, último mensaje, etc.)
          cargarConversaciones();
          // Solo recargar mensajes si es de la conversación que el agente tiene abierta
          if (activa?.id && String(payload.new?.conversacion_id) === String(activa.id)) {
            console.log('[REALTIME] Nuevo mensaje en conversación activa');
            cargarMensajes(activa.id);
          }
        }
      )
      .subscribe((status) => {
        console.log('[REALTIME] Estado canal:', status);
      });

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  // ── Polling de respaldo: cada 30s por si Realtime se desconecta ──
  useEffect(() => {
    const interval = setInterval(() => {
      cargarConversaciones();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // ── Polling mensajes de respaldo: cada 15s solo si hay conversación abierta ──
  useEffect(() => {
    if (!conversacionActiva?.id) return;

    const interval = setInterval(() => {
      const activa = conversacionActivaRef.current;
      if (!activa?.id) return;
      cargarMensajes(activa.id);
      cargarEstadoOperativo(activa.id);
    }, 15000);

    return () => clearInterval(interval);
  }, [conversacionActiva?.id]);

  // ── Seleccionar conversación en modo LECTURA ──
  // NO auto-asigna al agente. Solo abre la conversación para ver.
  // La asignación ocurre solo cuando el agente:
  //   1. Hace clic en "Tomar" (tomarConversacion)
  //   2. Envía un mensaje (enviarMensaje)
  const seleccionarConversacion = async (conv) => {
    setConversacionActiva(conv);

    // Marcar como leída si tiene unread
    if (conv.unread) {
      try {
        await authFetch(
          `${API_URL}/api/dashboard/conversacion/${conv.id}/marcar-leida`,
          { method: 'POST' }
        );
        // Actualizar localmente para que el dot desaparezca inmediato
        setConversaciones(prev =>
          prev.map(c => c.id === conv.id ? { ...c, unread: false } : c)
        );
      } catch (err) {
        console.error('Error marcando como leída:', err);
      }
    }
  };

  // Agente actual: el que seleccionÃ³ en el selector de agentes reales
  // Si no seleccionÃ³ ninguno, usar el primero disponible como fallback
  const agenteActualId = agenteLogueadoId || null; // null hasta que el agente seleccione su usuario

  const tomarConversacion = async () => {
    if (!conversacionActiva?.id) return;
    if (!agenteActualId) {
      alert('No hay agentes disponibles');
      return;
    }

    try {
      const response = await authFetch(
        `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/tomar`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ agente_id: agenteActualId }),
        }
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        alert(`âŒ Error: ${error?.error || 'No se pudo tomar la conversaciÃ³n'}`);
        return;
      }

      alert('âœ… ConversaciÃ³n tomada correctamente');
      await cargarConversaciones();
    } catch (error) {
      console.error('Error tomando conversaciÃ³n:', error);
      alert('âŒ Error de conexiÃ³n');
    }
  };

  const transferirConversacion = async () => {
    if (!conversacionActiva?.id) return;

    const categoria = prompt(
      'Â¿A quÃ© categorÃ­a transferir?\n\nOpciones:\n- ventas\n- soporte\n- atencion'
    );

    if (!categoria) return;

    const categoriaNormalizada = categoria.toLowerCase().trim();
    const categoriasValidas = ['ventas', 'soporte', 'atencion', 'marketing'];

    if (!categoriasValidas.includes(categoriaNormalizada)) {
      alert('âŒ CategorÃ­a invÃ¡lida. Debe ser: ventas, soporte o atencion');
      return;
    }

    try {
      const response = await authFetch(
        `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/transferir`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ categoria: categoriaNormalizada }),
        }
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        alert(`âŒ Error: ${error?.error || 'No se pudo transferir'}`);
        return;
      }

      alert(`âœ… ConversaciÃ³n transferida a ${categoriaNormalizada}`);
      await cargarConversaciones();
    } catch (error) {
      console.error('Error transfiriendo conversaciÃ³n:', error);
      alert('âŒ Error de conexiÃ³n');
    }
  };

  const cerrarConversacion = async () => {
    if (!conversacionActiva?.id) return;
    if (!agenteActualId) {
      alert('No hay agentes disponibles');
      return;
    }

    const motivo = prompt(
      'Motivo de cierre:\n\n' +
        '1 - Problema resuelto\n' +
        '2 - Cliente desiste\n' +
        '3 - Derivado a otra Ã¡rea\n' +
        '4 - No responde\n' +
        '5 - Otro\n\n' +
        'IngresÃ¡ el nÃºmero o descripciÃ³n:'
    );

    if (!motivo) return;

    const motivosMap = {
      '1': 'Problema resuelto',
      '2': 'Cliente desiste',
      '3': 'Derivado a otra Ã¡rea',
      '4': 'No responde',
      '5': 'Otro',
    };

    const motivoFinal = motivosMap[motivo] || motivo;

    if (!window.confirm(`Â¿Cerrar esta conversaciÃ³n?\n\nMotivo: ${motivoFinal}`)) return;

    try {
      const response = await authFetch(
        `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/cerrar`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            motivo: motivoFinal,
            agente_id: agenteActualId,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        alert(`âŒ Error: ${error?.error || 'No se pudo cerrar'}`);
        return;
      }

      alert('âœ… ConversaciÃ³n cerrada correctamente');
      setConversacionActiva(null);
      setMensajes([]);
      setDatosCliente(null);
      setEstadoOperativoBackend(null);
      await cargarConversaciones();
    } catch (error) {
      console.error('Error cerrando conversaciÃ³n:', error);
      alert('âŒ Error de conexiÃ³n');
    }
  };

  // ── Finalizar: unifica "Cerrar" + "Marcar Resuelto" en un solo paso ──
  // Recibe el motivo desde el mini-modal del ContextPanel
  // FIX auditor: (1) usa area Y categoria con normalización (bug sincronización 03/05)
  //              (2) maneja ventas (antes no cerraba para agentes ventas)
  //              (3) siempre cierra aunque guardarEstadoOperativo no aplique
  const finalizarConversacion = async (motivo) => {
    if (!conversacionActiva?.id) return;
    if (!agenteActualId) {
      alert('No hay agentes disponibles');
      return;
    }

    const motivoFinal = motivo || 'Problema resuelto';

    // FIX (1): normalizar area desde ambos campos, igual que ContextPanel
    const rawArea = (conversacionActiva.categoria || conversacionActiva.area || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    let areaNormalizada = null;
    if (rawArea.includes('ventas') || rawArea.includes('venta') || rawArea.includes('comercial')) areaNormalizada = 'ventas';
    else if (rawArea.includes('soporte') || rawArea.includes('tecnico') || rawArea.includes('tecnica')) areaNormalizada = 'soporte';
    else if (rawArea.includes('atencion') || rawArea.includes('administrativo') || rawArea.includes('admin')) areaNormalizada = 'atencion';
    // FIX auditor: default a atencion si no matchea nada (evita null por bug sincronización)
    if (!areaNormalizada) areaNormalizada = 'atencion';

    try {
      // 1. Marcar estado operativo como "Resuelto" según área
      if (areaNormalizada === 'atencion') {
        await guardarEstadoOperativo({
          area: 'atencion',
          campo: 'estado_atencion',
          valor: 'Resuelto',
          proxima_accion: 'Sin acción pendiente',
          observacion: motivoFinal,
        });
      } else if (areaNormalizada === 'soporte') {
        await guardarEstadoOperativo({
          area: 'soporte',
          campo: 'estado_soporte',
          valor: 'Resuelto',
          proxima_accion: 'Sin acción pendiente',
          observacion: motivoFinal,
        });
      } else if (areaNormalizada === 'ventas') {
        // FIX (2): ventas también marca estado operativo al finalizar
        // No forzar "Venta perdida" — usar el motivo real del agente
        await guardarEstadoOperativo({
          area: 'ventas',
          campo: 'etapa_ventas',
          valor: motivoFinal,
          proxima_accion: 'Sin acción pendiente',
          observacion: motivoFinal,
        });
      }
      // Si areaNormalizada es null (ej: marketing u otro), no marca estado operativo
      // pero igual cierra la conversación (FIX 3)

      // 2. Cerrar la conversación en el backend
      const response = await authFetch(
        `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/cerrar`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            motivo: motivoFinal,
            agente_id: agenteActualId,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        alert(`❌ Error: ${error?.error || 'No se pudo cerrar'}`);
        return;
      }

      // 3. Limpiar estado local
      setConversacionActiva(null);
      setMensajes([]);
      setDatosCliente(null);
      setEstadoOperativoBackend(null);
      await cargarConversaciones();
    } catch (error) {
      console.error('Error finalizando conversación:', error);
      alert('❌ Error de conexión');
    }
  };

  const toggleIA = async () => {
    if (!conversacionActiva?.id || cambiandoIA) return;
    if (!agenteActualId) {
      alert('No hay agentes disponibles');
      return;
    }

    const iaEstaActiva = conversacionActiva.ia_activa !== false;
    const activar = !iaEstaActiva;

    const confirmacion = window.confirm(
      activar
        ? 'Â¿Reactivar IA en esta conversaciÃ³n?'
        : 'Â¿Anular IA en esta conversaciÃ³n?'
    );

    if (!confirmacion) return;

    try {
      setCambiandoIA(true);

      const response = await authFetch(
        `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/toggle-ia`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ia_activa: activar,
            agente_id: agenteActualId,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        alert(`âŒ Error: ${error?.error || 'No se pudo cambiar el estado de IA'}`);
        return;
      }

      await cargarConversaciones();
      await cargarMensajes(conversacionActiva.id);

      const responseConv = await authFetch(
        `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}`
      );
      const dataConv = await responseConv.json();

      if (dataConv?.conversacion) {
        setConversacionActiva(dataConv.conversacion);
      }

      alert(activar ? 'âœ… IA reactivada' : 'âœ… IA anulada');
    } catch (error) {
      console.error('Error cambiando IA:', error);
      alert('âŒ Error de conexiÃ³n');
    } finally {
      setCambiandoIA(false);
    }
  };

  const enviarMensaje = async () => {
    if (!conversacionActiva?.id) return;

    const contenido = (nuevoMensaje || '').trim();
    if (!contenido) return;

    if (!agenteActualId) {
      alert('No hay agentes disponibles');
      return;
    }

    try {
      setEnviandoMensaje(true);

      // Si la conversación no tiene agente, auto-asignar al enviar mensaje
      if (!conversacionActiva.agente_id) {
        await authFetch(
          `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/tomar`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ agente_id: agenteActualId }),
          }
        ).catch(() => {}); // No bloquear el envío si falla la asignación
      }

      const response = await authFetch(
        `${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/mensaje`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            contenido,
            agente_id: agenteActualId,
          }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        alert(`âŒ Error: ${data?.error || 'No se pudo enviar el mensaje'}`);
        return;
      }

      setNuevoMensaje('');
      await cargarMensajes(conversacionActiva.id);
      await cargarConversaciones();
    } catch (error) {
      console.error('Error enviando mensaje:', error);
      alert('âŒ Error de conexiÃ³n enviando mensaje');
    } finally {
      setEnviandoMensaje(false);
    }
  };


  // â”€â”€ FunciÃ³n compartida para limpiar estado al cerrar/confirmar â”€â”€â”€â”€
  const limpiarConversacionActiva = () => {
    setConversacionActiva(null);
    setMensajes([]);
    setDatosCliente(null);
    setEstadoOperativoBackend(null);
  };

  // â”€â”€ Hooks de Ã¡rea â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const ventas = useVentas({
    conversacionActiva, mensajes, datosCliente, estadoOperativoBackend,
    guardarEstadoOperativo, agentes, agenteActualId, currentUser,
    cargarConversaciones, limpiarConversacionActiva,
  });

  const atencion = useAtencion({
    conversacionActiva, estadoOperativoBackend, guardarEstadoOperativo,
  });

  const soporte = useSoporte({
    conversacionActiva, estadoOperativoBackend, guardarEstadoOperativo,
    agentes, agenteActualId, currentUser,
    cargarConversaciones, limpiarConversacionActiva,
  });

  const conversacionesPorVista = useMemo(() => {
    return conversaciones.filter((c) => {
      if (!tieneAccesoArea(c.categoria || c.area)) return false;
      if (vistaActiva === 'historial') return c.estado === 'cerrada';
      return ESTADOS_ACTIVOS.includes(c.estado);
    });
  }, [conversaciones, vistaActiva, selectedDemoUserId]);

  const conversacionesFiltradas = useMemo(() => {
    return conversacionesPorVista.filter((c) => {
      const nombre = c.nombre_cliente?.toLowerCase() || '';
      const telefono = c.telefono || '';
      const busquedaNormalizada = busqueda.toLowerCase().trim();

      const coincideBusqueda =
        busquedaNormalizada === '' ||
        nombre.includes(busquedaNormalizada) ||
        telefono.includes(busquedaNormalizada);

      if (!coincideBusqueda) return false;

      if (filtro === 'todas') return true;
      if (filtro === 'pendientes') return !c.agente_id && c.estado !== 'cerrada';
      if (filtro === 'criticas') return c.prioridad === 'critica';
      if (filtro === 'derivadas') return !!c.derivada_ia || c.estado === 'escalada';
      if (filtro === 'vistas') return !!c.vista_sin_responder;
      if (filtro === 'soporte') return c.categoria === 'soporte' || c.area === 'soporte';
      if (filtro === 'ventas') {
        return c.categoria === 'ventas' || c.area === 'ventas';
      }
      if (filtro === 'atencion') return c.categoria === 'atencion' || c.area === 'atencion';
      if (filtro === 'marketing') return c.categoria === 'marketing' || c.area === 'marketing';

      // Subfiltros de área: ventas_ia, ventas_derivadas, atencion_ia, etc.
      // Filtrar por área base, el Inbox se encarga del sub-filtro IA/Derivadas
      const subMatch = filtro.match(/^(.+)_(ia|derivadas)$/);
      if (subMatch) {
        const areaBase = subMatch[1];
        return c.categoria === areaBase || c.area === areaBase;
      }

      return true;
    });
  }, [busqueda, conversacionesPorVista, filtro]);

  const conversacionesOrdenadas = useMemo(() => {
    const prioridadValor = (conv) => {
      if (conv.estado === 'escalada' || conv.derivada_ia) return 0;
      if (conv.prioridad === 'critica') return 1;
      if (!conv.agente_id) return 2;
      return 3;
    };

    const sorted = [...conversacionesFiltradas].sort((a, b) => {
      // ── Fix: la conversación activa siempre queda primera ──
      // Evita que se mueva de lugar cuando otro chat recibe un mensaje
      const activaId = conversacionActivaRef.current?.id;
      if (activaId) {
        if (a.id === activaId) return -1;
        if (b.id === activaId) return 1;
      }

      const prioridadA = prioridadValor(a);
      const prioridadB = prioridadValor(b);

      if (prioridadA !== prioridadB) return prioridadA - prioridadB;

      const fechaA = new Date(a.updated_at || a.created_at || 0).getTime();
      const fechaB = new Date(b.updated_at || b.created_at || 0).getTime();
      return fechaB - fechaA;
    });

    return sorted;
  }, [conversacionesFiltradas]);

  const stats = useMemo(
    () => ({
      activas: conversaciones.filter((c) => tieneAccesoArea(c.categoria || c.area) && c.estado !== 'cerrada').length,
      cerradas: conversaciones.filter((c) => tieneAccesoArea(c.categoria || c.area) && c.estado === 'cerrada').length,
      pendientes: conversaciones.filter(
        (c) => tieneAccesoArea(c.categoria || c.area) && !c.agente_id && c.estado !== 'cerrada'
      ).length,
      criticas: conversaciones.filter(
        (c) =>
          tieneAccesoArea(c.categoria || c.area) &&
          c.prioridad === 'critica' &&
          c.estado !== 'cerrada'
      ).length,
      derivadas: conversaciones.filter(
        (c) =>
          tieneAccesoArea(c.categoria || c.area) &&
          (c.derivada_ia || c.estado === 'escalada') &&
          c.estado !== 'cerrada'
      ).length,
      vistas: conversaciones.filter(
        (c) => tieneAccesoArea(c.categoria || c.area) && c.vista_sin_responder && c.estado !== 'cerrada'
      ).length,
    }),
    [conversaciones, selectedDemoUserId]
  );

  const categoryCounts = useMemo(() => {
    const activas = conversaciones.filter(
      (c) => ESTADOS_ACTIVOS.includes(c.estado) && tieneAccesoArea(c.categoria || c.area)
    );

    const esCategoria = (conv, categoria) =>
      conv.categoria === categoria || conv.area === categoria;

    return {
      todas: activas.length,
      soporte: activas.filter((c) => esCategoria(c, 'soporte')).length,
      ventas: activas.filter((c) => esCategoria(c, 'ventas')).length,
      atencion: activas.filter((c) => esCategoria(c, 'atencion')).length,
      marketing: activas.filter((c) => esCategoria(c, 'marketing')).length,
    };
  }, [conversaciones, selectedDemoUserId]);

  const areaMetrics = useMemo(() => {
    const activas = conversaciones.filter(
      (c) => ESTADOS_ACTIVOS.includes(c.estado) && tieneAccesoArea(c.categoria || c.area)
    );

    const convVentas = activas.filter((c) => c.categoria === 'ventas' || c.area === 'ventas');
    const convAtencion = activas.filter((c) => c.categoria === 'atencion' || c.area === 'atencion');
    const convSoporte = activas.filter((c) => c.categoria === 'soporte' || c.area === 'soporte');
    const convMarketing = activas.filter((c) => c.categoria === 'marketing' || c.area === 'marketing');

    const ventasCerradas = convVentas.filter(
      (c) => (ventas.obtenerVentaLocal(c)?.etapa || '') === 'Venta confirmada'
    ).length;
    const ventasPendientes = convVentas.filter((c) => {
      const etapa = ventas.obtenerVentaLocal(c)?.etapa || '';
      return etapa !== 'Venta confirmada' && etapa !== 'Venta perdida' && etapa !== 'Sin cobertura expansiÃ³n';
    }).length;
    const ventasInstalacion = convVentas.filter((c) => {
      const etapa = ventas.obtenerVentaLocal(c)?.etapa || '';
      return etapa === 'Venta confirmada' || c.estado === 'pendiente_instalacion' || c.estado === 'venta_confirmada';
    }).length;

    const atencionPago = convAtencion.filter(
      (c) => (atencion.obtenerAtencionLocal(c)?.estadoAdministrativo || '') === 'Esperando pago'
    ).length;
    const atencionResuelto = convAtencion.filter(
      (c) => (atencion.obtenerAtencionLocal(c)?.estadoAdministrativo || '') === 'Resuelto'
    ).length;
    const atencionPendiente = convAtencion.filter(
      (c) => (atencion.obtenerAtencionLocal(c)?.estadoAdministrativo || '') === 'Pendiente de revisiÃ³n'
    ).length;

    const soporteVisita = convSoporte.filter(
      (c) => (soporte.obtenerSoporteLocal(c)?.visitaTecnica || '') === 'SÃ­'
    ).length;
    const soporteCurso = convSoporte.filter(
      (c) => (soporte.obtenerSoporteLocal(c)?.estadoTecnico || '') === 'DiagnÃ³stico en curso'
    ).length;
    const soporteResuelto = convSoporte.filter(
      (c) => (soporte.obtenerSoporteLocal(c)?.estadoTecnico || '') === 'Resuelto'
    ).length;

    if (filtro === 'ventas' && areasHabilitadas.includes('ventas')) {
      return {
        titulo: 'Resumen Ventas',
        items: [
          { label: 'Pendientes', value: ventasPendientes },
          { label: 'Confirmadas', value: ventasCerradas },
          { label: 'InstalaciÃ³n', value: ventasInstalacion },
        ],
      };
    }

    if (filtro === 'atencion' && areasHabilitadas.includes('atencion')) {
      return {
        titulo: 'Resumen AtenciÃ³n',
        items: [
          { label: 'Pendientes', value: atencionPendiente },
          { label: 'Esperando pago', value: atencionPago },
          { label: 'Resueltos', value: atencionResuelto },
        ],
      };
    }

    if (filtro === 'marketing' && areasHabilitadas.includes('marketing')) {
      return {
        titulo: 'Resumen Marketing',
        items: [
          { label: 'Leads', value: convMarketing.length },
        ],
      };
    }

    if (filtro === 'soporte' && areasHabilitadas.includes('soporte')) {
      return {
        titulo: 'Resumen Soporte',
        items: [
          { label: 'En curso', value: soporteCurso },
          { label: 'Con visita', value: soporteVisita },
          { label: 'Resueltos', value: soporteResuelto },
        ],
      };
    }

    const generalItems = [];
    if (areasHabilitadas.includes('ventas')) generalItems.push({ label: 'Ventas', value: convVentas.length });
    if (areasHabilitadas.includes('atencion')) generalItems.push({ label: 'AtenciÃ³n', value: convAtencion.length });
    if (areasHabilitadas.includes('soporte')) generalItems.push({ label: 'Soporte', value: convSoporte.length });
    if (areasHabilitadas.includes('marketing')) generalItems.push({ label: 'Marketing', value: convMarketing.length });

    return {
      titulo: 'Resumen General',
      items: generalItems,
    };
  }, [conversaciones, ventas.ventasLocalData, atencion.atencionLocalData, soporte.soporteLocalData, filtro, selectedDemoUserId]);

  const emptyStateConfig = useMemo(() => {
    if (filtro === 'ventas') {
      return {
        icono: '',
        titulo: 'Bandeja de Ventas',
        texto: 'SeleccionÃ¡ un lead para ver etapa comercial, prÃ³xima acciÃ³n, cobertura y seguimiento.',
      };
    }

    if (filtro === 'soporte') {
      return {
        icono: '',
        titulo: 'Bandeja de Soporte',
        texto: 'SeleccionÃ¡ un caso para ver diagnÃ³stico, estado tÃ©cnico, visita y acciones BCM.',
      };
    }

    if (filtro === 'atencion') {
      return {
        icono: '',
        titulo: 'Bandeja de AtenciÃ³n',
        texto: 'SeleccionÃ¡ una conversaciÃ³n para ver deuda, factura, seguimiento y acciones administrativas.',
      };
    }

    return {
      icono: '',
      titulo: 'Inbox General',
      texto: 'SeleccionÃ¡ una conversaciÃ³n para ver los mensajes.',
    };
  }, [filtro]);

  // â”€â”€ FIX: categoriaActiva ahora cae al filtro activo si la conversaciÃ³n
  //         no tiene categoria/area en la BD â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const categoriaActiva = useMemo(() => {
    if (conversacionActiva) {
      return conversacionActiva.categoria || conversacionActiva.area || filtro || null;
    }
    if (filtro === 'ventas' || filtro === 'soporte' || filtro === 'atencion') {
      return filtro;
    }
    return null;
  }, [conversacionActiva, filtro]);

  const etiquetaCanalIA = (conv) => {
    return conv.ia_activa === false ? 'ðŸ‘¤ HUMANO' : 'ðŸ¤– IA ACTIVA';
  };

  const obtenerBadgeEstado = (conv) => {
    const categoria = conv.categoria || conv.area;

    if (categoria === 'ventas') {
      return {
        texto: ventas.obtenerVentaLocal(conv)?.etapa || 'Lead nuevo',
        estilo: {
          background: '#EEF2FF',
          color: '#4338CA',
          border: '1px solid #C7D2FE',
        },
      };
    }

    if (categoria === 'atencion') {
      return {
        texto:
          (conversacionActiva?.id === conv.id
            ? (atencion.atencionActual?.estadoAdministrativo || atencion.obtenerAtencionLocal(conv)?.estadoAdministrativo)
            : atencion.obtenerAtencionLocal(conv)?.estadoAdministrativo) ||
          'Pendiente de revisiÃ³n',
        estilo: {
          background: '#ECFDF5',
          color: '#047857',
          border: '1px solid #A7F3D0',
        },
      };
    }

    if (categoria === 'soporte') {
      return {
        texto: soporte.obtenerSoporteLocal(conv)?.estadoTecnico || 'Pendiente de revisiÃ³n',
        estilo: {
          background: '#FFF7ED',
          color: '#C2410C',
          border: '1px solid #FED7AA',
        },
      };
    }

    return null;
  };

  // Guard de autenticaciÃ³n
  if (!autenticado) return <Login onLogin={handleLogin} />;

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando dashboard...</p>
      </div>
    );
  }

  const ventaActual = ventas.ventaActual;
  const atencionActual = atencion.atencionActual;
  const soporteActual = soporte.soporteActual;

  // ISPCube action handlers for ContextPanel
  const onVerFactura = async () => {
    try {
      const convId = conversacionActiva.id;
      const resp = await authFetch(`${API_URL}/api/dashboard/ispcube/factura/${convId}`);
      const data = await resp.json();
      if (!resp.ok) { alert(`âŒ ${data.error || 'Error buscando factura'}`); return; }
      if (!data.factura) { alert(`â„¹Ã¯Â¸Â ${data.cliente}: No se encontraron facturas recientes`); return; }
      const f = data.factura;
      const venc = new Date(f.vencimiento).toLocaleDateString('es-AR');
      const texto = `ðŸ§¾ Factura ${f.numero} â€” ${f.periodo}\nðŸ’° Total: $${f.total}\nðŸ“… Vencimiento: ${venc}\nðŸ“„ ${f.url}`;
      if (window.confirm(`${texto}\n\nÂ¿Enviar al cliente por WhatsApp?`)) {
        await authFetch(`${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/mensaje`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ contenido: texto, agente_id: agenteActualId }),
        });
        await cargarMensajes(conversacionActiva.id);
      }
    } catch (e) { alert('âŒ Error de conexiÃ³n'); }
  };

  const onGenerarLinkMP = async () => {
    try {
      const convId = conversacionActiva.id;
      const resp = await authFetch(`${API_URL}/api/dashboard/ispcube/link-pago/${convId}`);
      const data = await resp.json();
      if (!resp.ok) { alert(`âŒ ${data.error || 'Error generando link'}`); return; }
      if (!data.link) { alert(`â„¹Ã¯Â¸Â ${data.cliente}: ${data.mensaje || 'No se pudo generar el link'}`); return; }
      const texto = `ðŸ’³ *Link de pago Mercado Pago:*\n${data.link}\n\nðŸ’° *Deuda pendiente:* ${data.balance}\n\nðŸ¦ *Portal cliente WeConnect*\nðŸŒ ${data.portal}\nðŸ¢ Empresa: ${data.portalEmpresa || '889'}\nðŸ‘¤ Usuario: ${data.portalUsuario || ''}\nðŸ”‘ Clave: ${data.portalPassword || ''}\n\nðŸ§ *Pago por transferencia con tu propio alias bancario*\nAlias\n${data.aliasSiro || ''}`;
      if (window.confirm(`${texto}\n\nÂ¿Enviar al cliente por WhatsApp?`)) {
        await authFetch(`${API_URL}/api/dashboard/conversacion/${conversacionActiva.id}/mensaje`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ contenido: texto, agente_id: agenteActualId }),
        });
        await cargarMensajes(conversacionActiva.id);
      }
    } catch (e) { alert('âŒ Error de conexiÃ³n'); }
  };

  return (
    <div className="app">
      {/* â•â•â• SIDEBAR â•â•â• */}
      <Sidebar
        filtro={filtro}
        setFiltro={setFiltro}
        areasHabilitadas={areasHabilitadas}
        onLogout={handleLogout}
      />

      {/* â•â•â• TOPBAR â•â•â• */}
      <Topbar
        busqueda={busqueda} setBusqueda={setBusqueda}
        agenteLogueadoId={agenteLogueadoId} setAgenteLogueadoId={setAgenteLogueadoId}
        agentes={agentes}
        selectedDemoUserId={selectedDemoUserId} setSelectedDemoUserId={setSelectedDemoUserId}
        demoUsers={demoUsers}
        stats={stats}
        vistaActiva={vistaActiva} setVistaActiva={setVistaActiva}
      />

      {/* REPORTE_OPERATIVO_VIEW */}
      {filtro === 'marketing' ? (
        <MarketingPanel onVerChat={(telefono) => {
          const conv = conversaciones.find(c => c.telefono === telefono);
          if (conv) {
            setFiltro('todas');
            setTimeout(() => seleccionarConversacion(conv), 200);
          } else {
            alert('No se encontró una conversación activa para este lead. Puede estar cerrada o no haberse creado aún.');
          }
        }} />
      ) : filtro === 'implementacion' ? (
        <ImplementacionPanel />
      ) : filtro === 'outbound' ? (
        outboundTab === 'v12' ? (
          <OutboundV12Panel onSwitchToV1={() => setOutboundTab('v1')} />
        ) : (
          <>
            <div style={{ position: 'absolute', top: 68, right: 160, zIndex: 50 }}>
              <button onClick={() => setOutboundTab('v12')} style={{ padding: '8px 16px', fontSize: '12px', fontWeight: 600, background: '#6c5ce7', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>V12 Auditoría →</button>
            </div>
            <OutboundPanel />
          </>
        )
      ) : filtro === 'metricas' ? (
        <ReporteOperativo
          conversaciones={conversaciones}
          agentes={agentes}
          ventas={ventas}
          atencion={atencion}
          soporte={soporte}
          areasHabilitadas={areasHabilitadas}
          currentUser={currentUser}
          onIrAConversacion={(convId) => {
            const conv = conversaciones.find((c) => String(c.id) === String(convId));
            if (conv) {
              setFiltro('todas');
              setTimeout(() => seleccionarConversacion(conv), 100);
            }
          }}
        />
      ) : filtro === 'catalogo' ? (
        <CatalogoPanel />
      ) : filtro === 'ads' ? (
        <AdsManagerPanel />
      ) : (
        <>
      {/* â•â•â• INBOX â•â•â• */}
      <Inbox
        filtro={filtro} setFiltro={setFiltro}
        areasHabilitadas={areasHabilitadas}
        categoryCounts={categoryCounts}
        conversacionesOrdenadas={conversacionesOrdenadas}
        todasLasConversaciones={conversacionesPorVista}
        conversacionActiva={conversacionActiva}
        seleccionarConversacion={seleccionarConversacion}
        obtenerBadgeEstado={obtenerBadgeEstado}
        etiquetaCanalIA={etiquetaCanalIA}
        agenteActualId={agenteActualId}
        agentes={agentes}
      />

      {/* â•â•â• CHAT â•â•â• */}
      <ChatPanel
        conversacionActiva={conversacionActiva}
        mensajes={mensajes}
        adjuntosRecientes={adjuntosRecientes}
        nuevoMensaje={nuevoMensaje} setNuevoMensaje={setNuevoMensaje}
        enviandoMensaje={enviandoMensaje} enviarMensaje={enviarMensaje}
        tomarConversacion={tomarConversacion}
        transferirConversacion={transferirConversacion}
        cerrarConversacion={cerrarConversacion}
        finalizarConversacion={finalizarConversacion}
        toggleIA={toggleIA} cambiandoIA={cambiandoIA}
        currentPermissions={currentPermissions}
        emptyStateConfig={emptyStateConfig}
        agenteLogueadoId={agenteLogueadoId}
        agenteActualId={agenteActualId}
        agentes={agentes}
      />

      {/* â•â•â• CONTEXT PANEL â•â•â• */}
      <ContextPanel
        conversacionActiva={conversacionActiva}
        categoriaActiva={categoriaActiva}
        areasHabilitadas={areasHabilitadas}
        currentPermissions={currentPermissions}
        datosCliente={datosCliente}
        ventaActual={ventaActual}
        accionRapidaVentas={ventas.accionRapidaVentas}
        abrirModalVentas={ventas.abrirModalVentas}
        confirmarVenta={ventas.confirmarVenta}
        actualizarVentaLocal={ventas.actualizarVentaLocal}
        guardarEstadoOperativo={guardarEstadoOperativo}
        guardandoEstado={guardandoEstado}
        atencionActual={atencionActual}
        accionRapidaAtencion={atencion.accionRapidaAtencion}
        actualizarAtencionLocal={atencion.actualizarAtencionLocal}
        soporteActual={soporteActual}
        accionRapidaSoporte={soporte.accionRapidaSoporte}
        actualizarSoporteLocal={soporte.actualizarSoporteLocal}
        diagnosticoBCM={soporte.diagnosticoBCM}
        ejecutandoAccionBCM={soporte.ejecutandoAccionBCM}
        mensajeBCM={soporte.mensajeBCM}
        reinicioConfirmado={soporte.reinicioConfirmado}
        ejecutarDiagnostico={soporte.ejecutarDiagnostico}
        reiniciarONU={soporte.reiniciarONU}
        verificarReinicioManual={soporte.verificarReinicioManual}
        desbloquearBCM={soporte.desbloquearBCM}
        confirmarSoporte={soporte.confirmarSoporte}
        onVerFactura={onVerFactura}
        onGenerarLinkMP={onGenerarLinkMP}
        tomarConversacion={tomarConversacion}
        transferirConversacion={transferirConversacion}
        cerrarConversacion={cerrarConversacion} /* fallback si finalizarConversacion no llega */
        finalizarConversacion={finalizarConversacion}
        toggleIA={toggleIA} cambiandoIA={cambiandoIA}
      />
        </>
      )}

      {/* â•â•â• SALES MODAL â•â•â• */}
      <SalesModal
        salesModal={ventas.salesModal}
        salesModalForm={ventas.salesModalForm} setSalesModalForm={ventas.setSalesModalForm}
        cerrarModalVentas={ventas.cerrarModalVentas}
        guardarAccionVentasModal={ventas.guardarAccionVentasModal}
        submittingSalesModal={ventas.submittingSalesModal}
      />
    </div>
  );
}

export default App;










